import Mark from 'mark.js'

const instance = new Mark('.c-book__page')

const markWord = word => {
  instance.mark(word, {
    acrossElements: true,
    exclude: ['.c-book-title__header']
  })
}

const unMarkWord = () => {
  instance.unmark()
}

export {
  markWord,
  unMarkWord
}
